"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../htmlSerializer/PrismicHtmlSerializer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var HeroCard = function HeroCardComponent(_ref) {
  var dataClient = _ref.dataClient,
      sliceData = _ref.sliceData;
  var _sliceData$primary = sliceData.primary,
      heroCardTitle = _sliceData$primary.hero_card_title,
      heroCardBody = _sliceData$primary.hero_card_body,
      heroCardImage = _sliceData$primary.hero_card_image;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__hero-card-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__hero-card"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__hero-card-text"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__hero-card-title"
  }, dataClient.textToMarkdown(heroCardTitle)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__hero-card-body"
  }, /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
    content: heroCardBody,
    baseClass: "hero-card-body"
  }))), /*#__PURE__*/_react["default"].createElement("img", {
    src: heroCardImage.url,
    alt: heroCardImage.name,
    className: "content-page__hero-card-image"
  }))));
};
/* eslint-disable camelcase */


HeroCard.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  sliceData: _propTypes["default"].shape({
    primary: _propTypes["default"].shape({
      hero_card_title: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
      hero_card_body: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
      hero_card_image: _propTypes["default"].shape({}).isRequired
    }).isRequired
  }).isRequired
};
var _default = HeroCard;
exports["default"] = _default;